<div class="f-stacked-bar-container" [ngStyle]="{ 'height.px': thickness }" [ngClass]="containerClass">
  @for (item of data; track item; let i = $index) {
  <div
    [ngClass]="item.barClass || ''"
    [@.disabled]="!animation"
    [@expandBar]="{
      value: animationStates[i],
      params: {
        width: item.percentage,
        duration: transitionDurationFraction,
        delay: animationDelay + (transitionDurationFraction * i) / data.length
      }
    }"
    class="bar-segment h-100"
  >
    @if (barSegmentTemplate) {
    <ng-container *ngTemplateOutlet="barSegmentTemplate; context: { $implicit: item.percentage }"></ng-container>
    }
  </div>
  }

  <div
    class="f-stacked-bar-tooltip-container"
    [ngStyle]="{ 'height.px': thickness, 'width.%': totalWidth }"
    [ngbPopover]="popoverTemplate && popoverTemplateOutlet"
    [triggers]="popoverTriggers"
    [placement]="popoverPlacement"
    [container]="'body'"
    [openDelay]="200"
  ></div>

  <ng-template #popoverTemplateOutlet>
    <ng-container *ngTemplateOutlet="$any(popoverTemplate); context: { $implicit: popoverContextData }"></ng-container>
  </ng-template>
</div>
